import * as THREE from 'three';
import gsap from 'gsap';
import { getRandom } from './utils';

export default class TrioMesh
{
    constructor(scene, terrainSize)
    {
        this.scene = scene;
        this.terrainSize = terrainSize;
        this.trioMeshes = [];
        this.speed1 = 1;
        this.speed2 = .5;

        this.setup();
    }

    setup()
    {
        this.material = new THREE.MeshStandardMaterial();
        this.luminosityFact = 3.;
        const group2 = new THREE.Object3D();
        
        for(let i=0; i<70; i++) 
        {
            this.material.color.setHSL(getRandom(0, 1), .5, .5);
            const x = getRandom(-this.terrainSize/2, this.terrainSize/2);
            const z = getRandom(-this.terrainSize/2, this.terrainSize/2);
            const xOffset = getRandom(-this.terrainSize/3, this.terrainSize/3);
		    //const zOffset = getRandom(-this.terrainSize/6, 0);
    
            const size = getRandom(2, 7);
    
            let mesh = new THREE.Mesh(new THREE.OctahedronGeometry(size, 0), this.material);
            mesh.size = size;
            mesh.position.set(x, size, z);	
            mesh.name = "intersectable";
    
            const small1 = mesh.clone();
            const scale = getRandom(0.2, 0.3);		
            small1.scale.set(scale, scale, scale);
            
            const small2 = small1.clone();
            const group1 = new THREE.Object3D();
            group1.add(mesh);
            group1.add(small1);
            group1.add(small2);

            //wireframe octas
            const meshSize = 3;
			let wfMesh = new THREE.LineSegments(
				new THREE.EdgesGeometry(new THREE.OctahedronGeometry(meshSize, 0)),
				new THREE.LineBasicMaterial()
            	);
            // let wfMesh = new THREE.Mesh(
			// 	new THREE.OctahedronGeometry(meshSize, 0),
			// 	new THREE.MeshLambertMaterial({
			// 		color: 0xFF5969,
			// 		wireframe: true
			// 	})
			// 	);
            wfMesh.position.set(xOffset, 15, z);
            group1.add(wfMesh);

            // let light = new THREE.PointLight(0xFF5969, 1, 50, 2);
            // light.position.set(x, size+50, z);
            // group2.add(light);
            
            this.scene.add(group1);
            this.scene.add(group2);

            this.trioMeshes.push(group1);
        }  
    };

    rotate(mesh) 
    {
        let tween = gsap
			.to(mesh.rotation, 5, {y: mesh.rotation.y+Math.PI/2, z: mesh.rotation.z+Math.PI/2});
        tween.play();
	}

    update(time) 
    {
        this.material.color.setHSL(Math.sin(time), 0.5, 0.5);
		const scale = (Math.sin(time)+6)/7;
		const ang1 = time/2;
        const ang2 = time/4;
        time += 0.01;

        for(let i=0; i<this.trioMeshes.length; i++) 
        {
            const octahedron = this.trioMeshes[i].children[0];

			const rad = octahedron.size;
			const small1 = this.trioMeshes[i].children[1];
            const small2 = this.trioMeshes[i].children[2];
            const wireFr = this.trioMeshes[i].children[3];

			small1.position.x = octahedron.position.x + rad * Math.sin(ang1*this.speed1) * Math.cos(ang2*this.speed1);
			small1.position.y = octahedron.position.y + rad * Math.sin(ang1*this.speed1) * Math.sin(ang2*this.speed1);
			small1.position.z = octahedron.position.z + rad * Math.cos(ang1*this.speed1);

			small2.position.x = octahedron.position.x + rad * Math.sin(-ang1*this.speed2) * Math.cos(-ang2*this.speed2);
			small2.position.y = octahedron.position.y + rad * Math.sin(-ang1*this.speed2) * Math.sin(-ang2*this.speed2);
            small2.position.z = octahedron.position.z + rad * Math.cos(-ang1*this.speed2);

            octahedron.scale.set(scale, scale, scale);
            wireFr.scale.set(scale, scale, scale);
		}
	};
    
    onAction(e)
    {
        for(let i=0; i<this.trioMeshes.length; i++) 
        {
            this.rotate(this.trioMeshes[i].children[0]);
	        this.rotate(this.trioMeshes[i].children[1]);
            this.rotate(this.trioMeshes[i].children[2]);
            this.rotate(this.trioMeshes[i].children[3]);
        }      
    };
}